export const regexName = /^[A-Za-z\s]+$/;
export const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const regexPhone = /^\d+$/;
export const regexInternalLink = /^\/(?!\/)/;
export const jsPattern = /\b(var|const|console\.log)\b/;
export const htmlPattern = /<("[^"]*"|'[^']*'|[^'">])*>/;
